export default __webpack_public_path__ + "static/media/mq-new-6.e28f738a.jpg";